package com.essntl.features.task.ui.addedittask.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.essntl.features.task.ui.addedittask.AddEditTaskState
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.rememberContains

@Composable
fun TaskServiceSection(
    state: AddEditTaskState,
) {
    val itinerary = rememberContains(
        state.sharedTaskState.getAllItineraries.data.orEmpty(),
        setOf(state.task.value.itineraryService?.itineraryId, state.task.value.itinerary),
    ) { itinerary -> itinerary.id }.firstOrNull()

    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(2.spacing),
        modifier = Modifier.fillMaxWidth(),
    ) {
        if (state.task.value.itinerary?.id.isNullOrEmpty()) {
            EsInput(
                value = state.task.value.itineraryService?.service?.title ?: "",
                onValueChange = {},
                placeholder = "-",
                label = "Service",
                enabled = false,
            )
        }
    }

    Spacer(modifier = Modifier.height(2.spacing))
    EsInput(
        value = itinerary?.proposal?.primaryClient?.firstName ?: "",
        onValueChange = {},
        placeholder = "-",
        label = "Traveller",
        enabled = false,
    )
}